import { RichTextField, SingleSelectField } from "components/RenderInput"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, FieldArray, isDirty, reset } from "redux-form"
import { renderReminderNotifications } from "./utils"
import { FORM_NAMES } from "constants/index"
import UnsavedAlertModal from "components/UnsavedAlertModal"

const CommunicationTab = ({ handleSave, tabIsActive, resetForm, isDirty }) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>COMMUNICATION</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col xs="auto" className="mt-1">
              <label>Reminder Notifications:</label>
            </Col>
            <Col xs="auto">
              <FieldArray
                name="reminderNotifications"
                reminderNotifications
                component={renderReminderNotifications}
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <label>Email Booking Confirmation:</label>
            </Col>
          </Row>
          <Row className="my-1">
            <Col>
              <Field name="emailConfirmation" component={RichTextField} />
            </Col>
          </Row>
        </CardBody>
      </Card>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  isDirty: isDirty(FORM_NAMES.SUB_CALENDARS)(state, ...["communication"]),
})

const mapDispatchToProps = dispatch => ({
  resetForm: () => dispatch(reset(FORM_NAMES.SUB_CALENDARS)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CommunicationTab)
